import React, { Fragment, useState } from "react";
import helpcenter from "../../assets/images/helpcenter.png";
import sabreHelp from "../../assets/images/hs_help.png";
import IntlMessage from "../helpers/IntlMessages";

const Help = ({ pid, gid, service }) => {

  console.log('service provider', service);
  const isSabre = service === "5" || String(service).toLowerCase() === "sabre";
  const [openIndex, setOpenIndex] = useState(-1);

 const faqs = isSabre
  ? [
      {
        q: <IntlMessage id="faq.reply.email.sabre.question" />,
        a: (
          <div>
            <IntlMessage id="faq.reply.email.sabre.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.rates.availability.question" />,
        a: (
          <div>
            <IntlMessage id="faq.rates.availability.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.different.language.question" />,
        a: (
          <div>
            <IntlMessage id="faq.different.language.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.pin.addin.question" />,
        a: (
          <div>
            <IntlMessage id="faq.pin.addin.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.knowledge.hub.question" />,
        a: (
          <div>
            <IntlMessage id="faq.knowledge.hub.answer" />
          </div>
        ),
      },
    ]
  : [
      {
        q: <IntlMessage id="faq.reply.email.myma.question" />,
        a: (
          <div>
            <IntlMessage id="faq.reply.email.myma.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.room.details.question" />,
        a: (
          <div>
            <IntlMessage id="faq.room.details.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.myma.different.language.question" />,
        a: (
          <div>
            <IntlMessage id="faq.myma.different.language.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.myma.pin.addin.question" />,
        a: (
          <div>
            <IntlMessage id="faq.myma.pin.addin.answer" />
          </div>
        ),
      },
      {
        q: <IntlMessage id="faq.knowledge.hub.question" />,
        a: (
          <div>
            <IntlMessage id="faq.knowledge.hub.answer" />
          </div>
        ),
      },
    ];

  return (
    <Fragment>
      <div className="page-content header-clear-small">
        {/* <div className="item-center">
          {isSabre ? (
            <img src={sabreHelp} style={{ width: "90%", height: "90%" }} alt="sabre" />
          ) : (
            <img src={helpcenter} style={{ width: "90%", height: "90%" }} alt="myma" />
          )}
        </div> */}

        <div className="content" style={{ padding: 16, maxWidth: 820, margin: '0 auto' }}>
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className="card"
              style={{
                marginBottom: 12,
                borderRadius: 10,
                overflow: 'hidden',
                border: '1px solid #e9edf2',
                boxShadow: '0 6px 18px rgba(20,24,31,0.06)',
                background: '#ffffff',
              }}
            >
              <div
                className="card-header"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '14px 16px',
                  cursor: 'pointer',
                  background: '#fbfcfe',
                  borderBottom: openIndex === idx ? '1px solid #f0f2f5' : 'none',
                }}
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
              >
                <div style={{ fontWeight: 400, fontSize: 15, color: '#1f2d3d' }}>{item.q}</div>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: openIndex === idx ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.18s', color: '#6b7280' }}
                >
                  <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              {openIndex === idx && (
                <div className="card-body" style={{ padding: 16, borderTop: '1px solid #f0f2f5', background: '#ffffff', color: '#334155', lineHeight: 1.6 }}>
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>

        <a className="item-center"
          href={isSabre ? "https://www.sabrehospitality.com/contact/customer-care/" : "https://help.myma.ai/en/articles/10503226-myma-ai-s-email-assistant-for-better-faster-email-responses"}
          target="_blank"
          rel="noreferrer"
        >
          <button className="btn-full btn button-myma-primary" style={{ width: '50%' }}>
            <span className="ml-1" style={{ textTransform: 'none' }}><IntlMessage id= "faq.helpcenter" /> {'>'} </span>
          </button>
        </a>
        {/* <div className="card card-mobile-style" style={{ borderRadius: '15px', height: `${window.innerHeight - 100}px` }}>
                     <div className="content">
                            Myma Digital Limited (we, us, our, Myma.ai, Aiva, Book Me Bob) complies with the New Zealand Privacy Act 1993 (the Act) when dealing with personal information. Personal information is information about an identifiable individual (a natural person). This policy sets out how we will collect, use, disclose and protect your personal information. This policy does not limit or exclude any of your rights under the Act. If you wish to seek further information on the Act, see www.privacy.org.nz.



                            CHANGES TO THIS POLICY

                            We may change this policy by uploading a revised policy onto the website. The change will apply from the date that we upload the revised policy. You should check back here periodically to see if the Privacy Policy has been updated as we will always show the date of the latest modification of the Privacy Policy at the top of the page so you can tell when it was last revised.

                        </div>
                    </div> */}
      </div>

    </Fragment>
  )
}

export default Help;